import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { useTranslation } from 'core/i18n/i18n';
import { FormSubmitSpinner } from 'modules/settings/components/custom-notifications/custom-notification-form.style';

export interface CustomNotificationFormSubmitButtonProps {
    labelKey: string;
    disabled?: boolean;
    isSubmitting?: boolean;
    onClick?: VoidFunction;
}

export const CustomNotificationFormSubmitButton: React.FC<CustomNotificationFormSubmitButtonProps> = ({
    labelKey,
    disabled = false,
    isSubmitting = false,
    onClick,
}) => {
    const { t } = useTranslation();

    return (
        <PocButton
            aria-label={t(labelKey)}
            variant="primary"
            size="medium"
            onClick={onClick}
            disabled={disabled || isSubmitting}
        >
            {isSubmitting ? <FormSubmitSpinner size="xSmall" /> : t(labelKey)}
        </PocButton>
    );
};
